"use client";

import { useCallback } from "react";
import { getErrorType } from "@/lib/utils";
import { ERROR_PAGE_ROUTE } from "@/constants/constants";
import type { ErrorResponse } from "@/types";
import { Actions } from "@/app/context/AppProvider/reducer";
import { toggleImageGenErrorModal, toggleTimeoutModal } from "@/app/context/AppProvider/actions";
import { useRouter } from "next/navigation";

export const useErrorDispatcher = (dispatch: React.Dispatch<Actions>) => {
  const router = useRouter();

  const dispatchErrorState = useCallback(
    (err: ErrorResponse) => {
      const errorState = getErrorType(err);
      if (errorState.showImageGenerationError) {
        dispatch(toggleImageGenErrorModal(true));
      } else if (errorState.showErrorPage) {
        router.push(ERROR_PAGE_ROUTE);
      } else {
        dispatch(toggleTimeoutModal(true));
      }
    },
    [dispatch],
  );

  return dispatchErrorState;
};
